import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import preloadImage from 'src/js/modules/utils/preload-image';
import ColumnsAppearanceSettingsContainer from '../containers/columns-appearance-settings-container';
import getColumnElementType from '../helpers/get-column-element-type';
import { columnsPreviewGifs } from '../constants/preview-gifs';
import settingIds from '../constants/setting-ids';

const {
  constants: { triggerTypes },
} = elementSettings;

const getAllColumnsSettings = () => {
  Object.values(columnsPreviewGifs).forEach((gif) => preloadImage(gif));

  return {
    id: settingIds.ALL_COLUMNS,
    triggerOn: triggerTypes.HOVER,
    priority: 1,
    settings: {
      parentSelector: 'ws-block[src*="/custom/"]',
      querySelector: 'ws-columns',
      columnQuerySelector: 'ws-column',
    },
    matches(element, config) {
      const { querySelector, columnQuerySelector, parentSelector } = config;

      return (
        element.matches(`${querySelector}, ${columnQuerySelector}`) &&
        element.closest(parentSelector)
      );
    },
    getTargetElement(element, config) {
      const { querySelector, columnQuerySelector } = config;

      if (element.matches(columnQuerySelector)) {
        return element.closest(querySelector);
      }

      return element;
    },
    getTargetElementType(element, config) {
      return getColumnElementType(element);
    },
    tabs: [
      {
        id: 'appearance',
        accordionTitle: i18next.t('All columns'),
        component: ColumnsAppearanceSettingsContainer,
      },
    ],
  };
};

export default getAllColumnsSettings;
